import { Component, h } from 'preact';
import { Localizer } from 'preact-i18n';
import * as appStyles from '../../assets/global.scss';
import { WidgetTab } from '../../common';
import Loader, { LoaderColor } from '../../common/Loader/Loader';
import { actions, BookingState, connectStore } from '../../store';
import { WithStyles, withStyles } from '../../style';
import { FinText } from '../../i18n';
import AmContinueModal from './AmContinueModal/AmContinueModal';

const mapStateToProps = ({
  ux: {
    proceedEnabled,
    loading: { getFlightAvailability, getAirCalendar },
  },
  currentTab,
  amState: { amSelection },
  selection: { locale },
}: BookingState) => ({
  proceedEnabled: currentTab === WidgetTab.AM ? amSelection.amProceedEnabled : proceedEnabled,
  loading: getFlightAvailability || getAirCalendar,
  am: currentTab === WidgetTab.AM,
  locale,
});

export interface ContinueButtonProps {
  class?: string;
}

interface StoreProps {
  loading: boolean;
  proceedEnabled: boolean;
  proceedToBooking: () => any;
  am: boolean;
  locale: string;
}

type EffectiveProps = ContinueButtonProps & StoreProps & WithStyles;

@withStyles(appStyles)
@connectStore({ mapStateToProps, actions })
export default class ContinueButton extends Component<ContinueButtonProps> {
  continue = (): void => {
    const { am, proceedToBooking } = this.props as EffectiveProps;
    const { showModal } = this.context.modal;
    if (am) {
      showModal(<AmContinueModal />);
    } else {
      proceedToBooking();
    }
  };

  render({ tx, loading, proceedEnabled, am }: EffectiveProps): h.JSX.Element {
    return (
      <Localizer>
        <button
          class={tx(this.props.class, 'ctaButton', 'ps-medium bold-type font-body-1 flex--self-end continueMinWidth', {
            am,
          })}
          onClick={this.continue}
          disabled={!proceedEnabled || loading}
          aria-disabled={!proceedEnabled || loading}
          aria-label={<FinText id="continueButton.ariaLabel" />}
        >
          <div class="relative">
            <span class={tx({ invisible: loading })} data-test-continue-label>
              <FinText id="continueButton.search" />
            </span>
            {loading && <Loader absolute center color={LoaderColor.GREY} />}
          </div>
        </button>
      </Localizer>
    );
  }
}
